<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Tallas disponibles</h6>
              <router-link
                :to="{ name: 'Supplies Create' }"
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-original-title="Agregar insumo"
              >
                Agregar <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>
            <div class="row align-items-end">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar producto..."
                  @input="fetchData(null)"
                />
              </div>
              <div class="col-md-8 mb-3 text-end">
                <input
                  type="file"
                  ref="fileInput"
                  accept=".csv,.txt"
                  style="display: none"
                  @change="handleFileImport"
                />
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary me-2"
                  @click="exportCsv"
                  :disabled="isExporting"
                >
                  <i class="fa fa-download me-1"></i> Exportar CSV
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-success"
                  @click="$refs.fileInput.click()"
                  :disabled="isImporting"
                >
                  <i class="fa fa-upload me-1"></i> Importar CSV
                </button>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Stock
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Semáforo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Última modificación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.ref }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.quantity }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': value.quantity <= value.low,
                        'bg-gradient-warning': value.quantity <= value.medium,
                        'bg-gradient-success': value.quantity >= value.medium,
                      }">
                        {{
                          value.quantity >= value.high
                            ? 'Alto'
                            : value.quantity > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Supplies Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      isExporting: false,
      isImporting: false,
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('inventory/fetchData', params);
    },
    async exportCsv() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch('inventory/exportCsv', this.searchQuery || null);
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'insumos.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        await Swal.fire('Listo', 'Archivo CSV descargado correctamente.', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al exportar el CSV',
        });
      } finally {
        this.isExporting = false;
      }
    },
    async handleFileImport(event) {
      const file = event.target.files?.[0];
      const fileInput = event.target;
      if (!file) return;
      if (this.isImporting) return;
      this.isImporting = true;
      try {
        await this.$store.dispatch('inventory/importCsv', file);
        await Swal.fire('Listo', 'Insumos importados correctamente.', 'success');
        this.fetchData();
      } catch (error) {
        const msg = error?.data?.message || 'Error al importar el CSV';
        const errors = error?.data?.errors;
        const detail = errors?.length
          ? `Errores en filas: ${errors.map((e) => e.fila).join(', ')}`
          : '';
        await Swal.fire({
          icon: 'error',
          title: 'Error al importar',
          text: detail ? `${msg} ${detail}` : msg,
        });
      } finally {
        this.isImporting = false;
        if (fileInput) fileInput.value = '';
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('inventory/delete', userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
